import React from 'react'

const LineSeperator = () => {
    return (
        <div className='line-seperator-container'>
            <span className="line-seperator"></span>
        </div>
    )
}

export default LineSeperator
